module.exports = __webpack_public_path__ + "img/jbt6447_cyb_02b_170.prt.41c6e981.jpg";